import 'core-js/stable'
// import 'regenerator-runtime/runtime'
import './load-client-scripts'

import get from 'lodash/get'
import eachRight from 'lodash/eachRight'
import replace from 'lodash/replace'

// Vue & axios
import Vue from 'vue'
import axios from 'axios'

import moment from 'moment'
import VueMoment from 'vue-moment'

import toastr from 'toastr'
import 'toastr/build/toastr.min.css'

// import Router from 'vue-router'

export const EventBus = new Vue()
import VueLodash from 'vue-lodash'
import lodash from 'lodash'

import VuejsDialog from 'vuejs-dialog'
import 'vuejs-dialog/dist/vuejs-dialog.min.css'

import './axios-config'

import BootstrapVue from 'bootstrap-vue/dist/bootstrap-vue.esm'

// Vendor plugins/components
import './vendor/coreui/components'

import rawDisplayer from '@core/js/helpers/raw-displayer'
import DataTable from '@core/js/components/Plugins/DataTable'
import RichTextEditor from '@core/js/components/Plugins/RichTextEditor'
import DateTimePicker from '@core/js/components/Plugins/DateTimePicker'
import Switch from '@core/js/components/Plugins/Switch'
import Phone from '@core/js/components/Plugins/Phone'
// import vSelectLocal from '@core/js/components/Plugins/Select' // (unused)
import SelectInput from '@core/js/components/Plugins/SelectInput'
import vSelect from 'vue-select'
import ImageStyle from '@core/js/components/Plugins/ImageStyle'
import Confirm from '@assets/js/components/Popup/Confirm'
import Alert from '@assets/js/components/Alert'
//import RenameItem from '@assets/js/components/Actions/RenameItem'

import VModal from 'vue-js-modal'
import fontawesome from '@fortawesome/fontawesome'
import VTooltip from 'v-tooltip'
// import * as VueGoogleMaps from 'vue2-google-maps'
import VueFileAgent from 'vue-file-agent'
// import 'vue-file-agent/dist/vue-file-agent.css'

import { createStore } from './store'
import { createLocales } from './vue-i18n-config'
// import VuePageTitle from 'vue-page-title'

import { events } from './bus'
import Helpers from './helpers'

// import App from './App' // Not needed when using Blade DOM templates

import Noty from 'noty'
import has from 'lodash/has'
import size from 'lodash/size'
import isEmpty from 'lodash/isEmpty'
import VueScrollTo from 'vue-scrollto'

// Account
import profileData from '@account/js/components/profile-data'
import socialConverter from '@account/js/components/social-converter'
import AuthComponent from '@account/js/components/AuthComponent'
import SignIn from '@account/js/views/Auth/SignIn'

// Services
import Services from '@services/js/components/services'
import ServicesFilters from '@services/js/components/inc/filters'
import ServicePage from '@services/js/components/service-page'
import ServiceForm from '@services/js/components/service-form'
import ServiceRegistration from '@services/js/components/service-registration'
import AccountServices from '@account/js/components/account/services'

import Tenders from '@tenders/js/components/tenders'
import TenderPage from '@tenders/js/components/tender-page'
import CatalogTabs from '@services/js/components/catalogue-tabs'
import TenderForm from '@tenders/js/components/tender-form'
import TenderRegistration from '@tenders/js/components/tender-registration'
import AccountTenders from '@tenders/js/components/account/tenders'

// Checkout
import CheckoutAddress from '@checkout/js/components/Address'
import CheckoutPaymentMethods from '@checkout/js/components/PaymentMethods'
import CheckoutTotals from '@checkout/js/components/Totals'
import Checkout from '@checkout/js/components/Checkout'

// Basket
import BasketTotals from '@basket/js/components/Totals'
import CartLinesSummary from '@basket/js/components/Lines'
import CartLines from '@basket/js/components/CartLines'
import CartMini from '@basket/js/components/MiniCart'
import Cart from '@basket/js/components/Cart'

// Companies
import companyData from '@companies/js/components/company-data'

// --- Filters ---
Vue.filter('formatDateYM', function (value) {
  if (value) {
    return moment(String(value)).format('YYYY/MM')
  }
})

// --- Plugins ---
Vue.use(VueLodash, { lodash })

Vue.use(BootstrapVue)
Vue.use(VuejsDialog)
Vue.use(VueMoment)
Vue.use(VTooltip)
Vue.use(fontawesome)
Vue.use(VModal, { dialog: true, injectModalsContainer: true })
Vue.use(VueFileAgent)
Vue.use(Helpers) // keep only once

Vue.use(VueScrollTo, {
  container: 'body',
  duration: 500,
  easing: 'ease',
  offset: 0,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true,
})

// --- Globals ---
window.moment = moment
window._get = get
window._eachRight = eachRight
window._replace = replace
window._has = has
window._size = size
window._empty = isEmpty
window.toastr = toastr
window.axios = axios

// --- Global components ---
Vue.component('RawDisplayer', rawDisplayer)
Vue.component('VSelect', vSelect) // register once

// Account
Vue.component('Profile', profileData)
Vue.component('SocialConverter', socialConverter)
Vue.component('AuthComponent', AuthComponent)
Vue.component('SignIn', SignIn)

// Services
Vue.component('Services', Services)
Vue.component('ServicesFilters', ServicesFilters)
Vue.component('ServicePage', ServicePage)
Vue.component('ServiceForm', ServiceForm)
Vue.component('ServiceRegistration', ServiceRegistration)
Vue.component('AccountServices', AccountServices)

Vue.component('CatalogueTabs', CatalogTabs)
Vue.component('Tenders', Tenders)
Vue.component('TenderPage', TenderPage)
Vue.component('TenderForm', TenderForm)
Vue.component('TenderRegistration', TenderRegistration)
Vue.component('AccountTenders', AccountTenders)

// Checkout
Vue.component('Checkout', Checkout)
Vue.component('CheckoutAddress', CheckoutAddress)
Vue.component('CheckoutPaymentMethods', CheckoutPaymentMethods)
Vue.component('CheckoutTotals', CheckoutTotals)

// Basket
Vue.component('BasketTotals', BasketTotals) // register once
Vue.component('CartLinesSummary', CartLinesSummary)
Vue.component('CartLines', CartLines)
Vue.component('CartMini', CartMini)
Vue.component('Cart', Cart)

// Companies
Vue.component('CompanyData', companyData)

// Custom plugins/components
Vue.component('CSwitch', Switch)
Vue.component('PDatetimepicker', DateTimePicker)
Vue.component('PRichtexteditor', RichTextEditor)
Vue.component('BDatatable', DataTable)
Vue.component('BImgStyle', ImageStyle)
Vue.component('FieldPhone', Phone)
Vue.component('FieldSelect', SelectInput)
Vue.component('Confirm', Confirm)
Vue.component('Alert', Alert)
//Vue.component('RenameItem', RenameItem)

// --- App factory ---
export function createApp() {
  const i18n = createLocales(window.locale)
  const store = createStore()

  Vue.prototype.$eventHub = new Vue()

  /**
   * Server-side settings & helpers
   */
  Vue.prototype.$app = window.settings
  Vue.prototype.$app.lang = window.locale
  Vue.prototype.$app.isLoggedIn =
    document
      .querySelector('meta[name="login-status"]')
      ?.getAttribute('content') || null

  /**
   * Object to FormData converter
   */
  let objectToFormData = (obj, form, namespace) => {
    let fd = form || new FormData()

    for (let property in obj) {
      if (!Object.prototype.hasOwnProperty.call(obj, property)) {
        continue
      }

      let formKey = namespace ? `${namespace}[${property}]` : property

      if (obj[property] === null) {
        fd.append(formKey, '')
        continue
      }
      if (typeof obj[property] === 'boolean') {
        fd.append(formKey, obj[property] ? '1' : '0')
        continue
      }
      if (obj[property] instanceof Date) {
        fd.append(formKey, obj[property].toISOString())
        continue
      }
      if (
        typeof obj[property] === 'object' &&
        !(obj[property] instanceof File)
      ) {
        objectToFormData(obj[property], fd, formKey)
        continue
      }
      fd.append(formKey, obj[property])
    }

    return fd
  }

  Vue.prototype.$app.objectToFormData = objectToFormData

  // Add translation helper
  Vue.prototype.trans = function (key) {
    return i18n.t(key)
  }

  // Mount with DOM template (Blade inside #app)
  const app = new Vue({
    store,
    i18n,
    beforeMount() {
      // Store config to vuex
      this.$store.commit('INIT', {
        config: {
          api: this.$app.appUrlClientApi,
          chunk_size: 256,
        },
        rootDirectory: {
          name: 'base',
          location: 'base',
          unique_id: 0,
        },
      })
    },
    mounted() {
      store.dispatch('basket/getBasket')
    },
    created() {
      // store.dispatch('getAppData')
    },
  })

  return { app, store }
}

// Auto-init if #app exists on the page
if (document.getElementById('app') !== null) {
  const { app } = createApp()
  app.$mount('#app')
}

/* --- Optional utilities (uncomment if you still need them) ---
// Example Noty helpers:
const noty = (type, text) => {
  new Noty({ layout: 'topRight', theme: 'bootstrap-v4', timeout: 2000, text, type }).show()
}
Vue.prototype.$app.noty = {
  alert: (text) => noty('alert', text),
  success: (text) => noty('success', text),
  error: (text) => noty('error', text),
  warning: (text) => noty('warning', text),
  info: (text) => noty('info', text),
}
*/
